import Cookies from 'js-cookie';
import { AUTH_COOKIES } from '../constants/cookies';

export const setLastActiveCookie = () => {
    Cookies.set(AUTH_COOKIES.LAST_ACTIVE, Date.now().toString(), {
        sameSite: 'Lax',
        secure: true,
        path: '/',
    });
};
